import { render, staticRenderFns } from "./button-tile.vue?vue&type=template&id=730fbf2c&"
import script from "./button-tile.vue?vue&type=script&lang=js&"
export * from "./button-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports